// extracted by mini-css-extract-plugin
module.exports = {"clubLogo":"offer-top_clubLogo__v6Avv","offerTop":"offer-top_offerTop__B11Hf","slogan":"offer-top_slogan___VKHY"};